export default "__VITE_ASSET__7ZAHUcqo__"